/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CompartmentNameQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("CompartmentNameQueryOperator");
    }

    getFixupPrototypeFunction() { return CompartmentNameQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<CompartmentNameQueryOperator>): CompartmentNameQueryOperator {
        let obj = Object.assign(new CompartmentNameQueryOperator(), model);
        CompartmentNameQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CompartmentNameQueryOperator>): CompartmentNameQueryOperator {
        if (!model) return null;
        return CompartmentNameQueryOperator.newInstance(<CompartmentNameQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CompartmentNameQueryOperator) {
        if (!obj) return;

        models.CompartmentNameQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CompartmentNameQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CompartmentNameQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Compartment Names to include
     */
    compartment_names: Array<string>;

}
